import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { DemoAccountForm } from "./DemoAccountForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { FormToolbar } from "../../common/form/FormToolbar";

interface IDemoAccountCreateProps {}

export const DemoAccountEdit = (props: IDemoAccountCreateProps) => {
  const notify = useNotification(props, "editSuccess");
  return (
    <Edit
      {...props}
      actions={<EditActions />}
      mutationMode="pessimistic"
      onSuccess={notify}
      title="Edit a demo account"
    >
      <DemoAccountForm isEdit toolbar={<FormToolbar showDeleteButton />} />
    </Edit>
  );
};
